// for disarrayifying arrays of length < 10000

export default function disarrayify(arr, keyword) {
  let newObj = {}
  arr.forEach( (item, n) => {
    let index
    if (n < 10) {
      index = '000' + n
    } else if (n < 100) {
      index = '00' + n
    } else if (n < 1000) {
      index = '0' + n
    } else {
      index = n
    }
    newObj[keyword + index] = item
  })
  return newObj
}


// WEBPACK FOOTER //
// ./src/helpers/disarrayify.js